/** Camera2D property formatter: the view-framing properties for the details panel. */
import { formatNode2DProperties } from '../../base/node2d/propertyFormatter';
import { Camera2DAnchorMode } from '../../../godot/scene/camera2d';
export function formatCamera2DProperties(properties) {
    const sections = [];
    sections.push({
        title: 'Camera',
        items: [
            { label: 'Zoom', value: `(${properties.zoom.x}, ${properties.zoom.y})` },
            { label: 'Offset', value: `(${properties.offset.x}, ${properties.offset.y})` },
            { label: 'Anchor Mode', value: anchorModeName(properties.anchor_mode) },
            { label: 'Enabled', value: properties.enabled ? 'Yes' : 'No' },
        ],
    });
    sections.push(...formatNode2DProperties(properties));
    return sections;
}
function anchorModeName(mode) {
    switch (mode) {
        case Camera2DAnchorMode.FIXED_TOP_LEFT:
            return 'Fixed Top-Left';
        case Camera2DAnchorMode.DRAG_CENTER:
            return 'Drag Center';
        default:
            return 'Unknown';
    }
}
//# sourceMappingURL=propertyFormatter.js.map